import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Title } from 'react-admin';

export default () => (
    <Card>
        <Title title="Loading ... " />
        <CardContent>
            <h3>Loading Page ...</h3>
        </CardContent>
    </Card>
);